import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import ItemsCases from "./items/index";
import { URL_AWS } from "../../constans/servidor";

const CasesOpen = () => {
  const [responseCase, setResponseCase] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCasesOpen = async () => {
    try {
      const casesOpen = await axios.post(
        // `http://localhost:3000/dev/getCasesOpen`
        `${URL_AWS}/ContactCategory/getCasesOpen`
      );
      if (casesOpen.data.data.length > 0) {
        setResponseCase(casesOpen.data.data);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Hubo un error al consultar los casos abiertos!");
      return;
    }
  };

  useEffect(() => {
    getCasesOpen();
  }, []);

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      {responseCase.length === 0 ? (
        <div className="cargando">
          <div className="loader" id="loader">
            Loading...
          </div>
        </div>
      ) : (
        <>
          <ul
            style={{
              display: "flex",
              flexWrap: "wrap",
              listStyle: "none",
              padding: 0,
            }}
          >
            {responseCase?.map((cases, index) => (
              <ItemsCases cases={cases} key={index} />
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default CasesOpen;
